import { COLOR_PALETTE } from 'constants/ui';

export const cardStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 16px',
  cursor: 'pointer',
  position: 'relative',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  transition: 'background-color 150ms ease',

  '&:hover, &:focus-within': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },

  '&:focus-visible': {
    outline: `2px solid ${COLOR_PALETTE.BRAND[7]}`,
    outlineOffset: '-2px',
  },
};

export const unreadDotStyles = {
  position: 'absolute',
  top: '16px',
  left: '6px',
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.BRAND[7],
};

export const iconWrapperStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2px',
};

export const contentStyles = {
  flex: 1,
  minWidth: 0,
};

export const messageStyles = {
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-word',
};

export const metaStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginTop: '4px',
};

export const timestampStyles = {
  flexShrink: 0,
};

export const learnMoreLinkStyles = {
  alignSelf: 'flex-start',
  color: COLOR_PALETTE.BRAND[7],
  textDecoration: 'none',
  cursor: 'pointer',

  '&:hover, &:focus': {
    textDecoration: 'underline',
  },
};

export const sourceEntityLinkStyles = {
  alignSelf: 'flex-start',
  color: COLOR_PALETTE.BRAND[7],
  textDecoration: 'none',
  cursor: 'pointer',

  '&:hover, &:focus': {
    textDecoration: 'underline',
  },
};

const starButtonStyles = {
  padding: '4px',
  flexShrink: 0,
  alignSelf: 'flex-start',
  marginTop: '2px',
  opacity: 0,
  transition: 'opacity 150ms ease',

  '.MuiBox-root:hover > &, .MuiBox-root:focus-within > &, &:focus, &[data-is-important]': {
    opacity: 1,
  },

  '&:focus': {
    background: ({ palette }) => `${palette.background.hoverDefault} !important`,
  },
};

export const getStarButtonStyles = isImportant => ({
  ...starButtonStyles,
  color: isImportant ? COLOR_PALETTE.ORANGE[6] : ({ palette }) => palette.text.placeholder,
});
